/* eslint-disable no-console */
export default {
  logEvent: (eventName, params) => {
    const label = `%c${eventName}: %c${params.action_id}; %c${params.interface_id}`;
    console.groupCollapsed(label, "color:#e87b33;", "color:#7b88db;", "color:#ff6347;");
    console.info(params);
    console.groupEnd(label);
  }
};